
export class TreeItemType {
    static SYSTEM_LAYOUT: string = "SYSTEM LAYOUT";
    static CELL: string = 'CELL';
    static KIT: string = 'Kit';
    static TOOL: string = 'Tool';
    static STATION: string = 'STATION';
}

export const MtlFolders: any = {
    'System Layout': [
        { title: 'Cells', HierarchicalDetailsType: TreeItemType.CELL },
        { title: 'Kits', HierarchicalDetailsType: TreeItemType.KIT },
        { title: 'Stations', HierarchicalDetailsType: TreeItemType.STATION },
        { title: 'Tools', HierarchicalDetailsType: TreeItemType.TOOL }
    ],
    'CELL': [
        { title: 'Stations', HierarchicalDetailsType: TreeItemType.STATION },
        { title: 'Tools', HierarchicalDetailsType: TreeItemType.TOOL }
    ],
    'STATION': [
        { title: 'Tools', HierarchicalDetailsType: TreeItemType.TOOL }
    ]
}

export class COLSAdminOwnerInfo {
    static NAME: string = "William Rust";
    static EMAIL: string = 'william.rust@gm.com';
}

export class SuperUserOwnerInfo {
    static NAME: string = "William Rust";
    static EMAIL: string = "william.rust@gm.com";
}
